import * as React from 'react'
import { styled } from 'next-yak'

import * as api from '@owl-nest/api-client/latest'
import { t } from '@owl-nest/localize'
import * as services from '@owl-nest/services'
import * as plume from '@ulule/owl-kit-components/next'

import { Comment } from './Comment'
import { CommentForm } from './CommentForm'
type CommentListProps = {
  comments: services.comment.Comment<boolean>[]
  meta: api.Pageable<services.comment.Comment<true>>['meta']
  objectId: number | string
  queryNext: () => void
  queryReplies: (commentId: number) => void
  replyToComment: (commentId: number, payload: api.CreateComment) => void
}

export function CommentList({
  comments,
  meta,
  queryNext,
  queryReplies,
  replyToComment,
}: CommentListProps): React.ReactElement<any> {
  const auth = services.user.useAuth()
  const [isFormOpen, setIsFormOpen] = React.useState<number[]>([])

  return (
    <Wrapper>
      {comments.map((comment) => {
        const hasMoreReplies = Boolean(
          comment.replies_count &&
            comment.replies &&
            comment.replies_meta !== null &&
            comment.replies_count > comment.replies.length,
        )

        return (
          <CommentNode key={comment.id}>
            <Comment comment={comment} onReply={() => setIsFormOpen([comment.id])} />

            {Boolean(comment.replies?.length) && (
              <CommentNodeChildrenWrapper>
                {comment.replies?.map((reply) => {
                  return <Comment comment={reply} onReply={() => setIsFormOpen([comment.id])} key={reply.id} />
                })}

                {hasMoreReplies && (
                  <ViewMoreCTA onClick={() => queryReplies(comment.id)}>{t('View more replies')}</ViewMoreCTA>
                )}
              </CommentNodeChildrenWrapper>
            )}

            {auth.type === 'loggedin' && isFormOpen.includes(comment.id) && (
              <CommentForm
                /* eslint-disable-next-line jsx-a11y/no-autofocus */
                autoFocus={true}
                currentUser={auth.user}
                onCancel={() => setIsFormOpen([])}
                onSubmit={async (values) => {
                  replyToComment(comment.id, {
                    comment: values.comment,
                  })
                  setIsFormOpen([])
                }}
                submitLabel={t('Reply')}
              />
            )}
          </CommentNode>
        )
      })}

      {meta.next && (
        <SeeMoreButton
          kind="secondary"
          onClick={() => {
            queryNext()
          }}
        >
          {t('See more')}
        </SeeMoreButton>
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 18px;

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    margin-bottom: 0;
  }
`

const CommentNode = styled.div`
  border-bottom: 1px solid ${plume.COLORS.BORDER_PRIMARY};

  &:first-child {
    border-top: 1px solid ${plume.COLORS.BORDER_PRIMARY};
  }
`

const SeeMoreButton = styled(plume.Button)`
  align-self: center;
  margin-top: 28px;
  // FIXME: Why is this needed?
  width: max-content;
`

const CommentNodeChildrenWrapper = styled.section`
  padding-left: 40px;
`

const ViewMoreCTA = styled(plume.LinkAsButton)`
  padding: 0;
  margin-bottom: 24px;
`
